import { Group } from '$synapse/models';

export class GroupCreationDTO {
  name: string;
  description: string;

  constructor(group: Partial<GroupCreationDTO> = {}) {
    this.name = group.name ?? '';
    this.description = group.description ?? '';
  }
}

export function mapToCreationGroupDTO(group: Group): GroupCreationDTO {
  return {
    name: group.name,
    description: group.description,
  };
}
